import { render, staticRenderFns } from "./BrokerCompensationOverview.vue?vue&type=template&id=55ae754f&scoped=true"
import script from "./BrokerCompensationOverview.vue?vue&type=script&lang=js"
export * from "./BrokerCompensationOverview.vue?vue&type=script&lang=js"
import style0 from "./BrokerCompensationOverview.vue?vue&type=style&index=0&id=55ae754f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae754f",
  null
  
)

export default component.exports